import { render, staticRenderFns } from "./ConfigurazioneGeneralePage.vue?vue&type=template&id=2d65a2e2"
import script from "./ConfigurazioneGeneralePage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneGeneralePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports